import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import {
  DxButtonComponent,
  DxCheckBoxComponent,
  DxDataGridComponent,
  DxLookupComponent,
  DxPopupComponent,
  DxTagBoxComponent,
  DxTemplateDirective,
  DxTextBoxComponent,
  DxValidationGroupComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { firstValueFrom, Observable } from 'rxjs';
import { StorageService } from 'src/app/shared/services/storage.service';
import * as sha512 from 'js-sha512';

import { ConvertError } from 'src/app/utils/gestione-errori';

import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { AggiornaPasswordModel } from 'src/app/shared/utils/ildato-gestione-password/aggiorna-password-model';
import { IlDatoNewPasswordComponent } from 'src/app/shared/utils/ildato-gestione-password/ildato-new-password/ildato-new-password.component';
import { UtentiService } from 'src/app/shared/services/utenti.service';
import { Utente } from 'src/app/models/utente';
import {
  DxiButtonComponent,
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { RUOLO_AMMINISTRATORE } from 'src/app/consts/const';
import { ResetPassword } from 'src/app/models/reset-password';
import { environment } from 'src/environments/environment';
import { RuoliService } from 'src/app/shared/services/ruoli.service';
import { Reparti } from 'src/app/models/reparti';
import { RepartiService } from 'src/app/shared/services/reparti.service';

@Component({
  selector: 'app-utenti',
  templateUrl: './utenti.component.html',
  styleUrls: ['./utenti.component.scss'],
  imports: [
    DxDataGridComponent,
    DxButtonComponent,
    DxPopupComponent,
    DxTextBoxComponent,
    DxTextBoxComponent,
    DxLookupComponent,
    DxValidatorComponent,
    DxLookupComponent,
    DxValidatorComponent,
    DxValidationGroupComponent,
    DxoExportComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxiColumnComponent,
    DxiButtonComponent,
    DxoLookupComponent,
    DxiValidationRuleComponent,
    DxTemplateDirective,
    IlDatoNewPasswordComponent,
    DxCheckBoxComponent,
    DxTagBoxComponent,
  ],
})
export class UtentiComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private utentiService = inject(UtentiService);
  private storService = inject(StorageService);
  private nS = inject(NavigatorService);
  private parametriService = inject(ParametriService);
  private ruoliService = inject(RuoliService);
  private repartiService = inject(RepartiService);

  @ViewChild('grid', { static: false }) tabella!: DxDataGridComponent;
  @ViewChild('targetGroup', { static: false })
  validationGroup?: DxValidationGroupComponent;

  columnResizingMode = 'widget';

  gestioneUtentiSource: any;
  permessiRuoliServiziSource: any;
  altezzaTabella = 100;
  popupVisible = false;
  popupResetPswVisible = false;
  newUtente?: Utente = new Utente();
  newPassword: string = '';
  idUtente?: number;
  password?: string;
  idZona?: number;
  idRuolo!: number;
  confermaPassword?: string;
  newConfermaPassword?: string;
  parametriPasswords: any;
  usernameResetPassword?: string;
  loadPanelVisible: boolean = false;
  idUfficio: any;
  listRuoli: any;
  listUffici: any;
  listReparti: Reparti[] = [];

  authBase: boolean = false;
  authAvanzato: boolean = false;
  passwordObbligatoria: boolean = true;
  messaggioErrore:string='';

  constructor() {
    const storService = inject(StorageService);

    super();

    this.storService = storService;
  }

  ngOnInit() {
    this.authBase = environment.authBase;
    this.authAvanzato = environment.authAvanzato;
    if (this.storService.utenteCorrente.ruoloString == RUOLO_AMMINISTRATORE) {
      this.loadLookUp();
      this.newPassword = '';
      this.loadParametriPasswords();
      this.loadUtenti(this.utentiService.list());
    } else {
      this.nS.goToHome();
    }
  }

  loadParametriPasswords() {
    this.parametriService.getParametriPasswords().subscribe({
      next: (res) => {
        this.parametriPasswords = res;
      },
      error: (error) => {
        if (error?.error?.title) {
          notify(error?.error?.title, 'error');
        } else {
          notify('Errore caricamento parametri password', 'error');
        }
      },
    });
  }

  loadLookUp() {
    //Ruoli
    this.ruoliService.list().subscribe({
      next: (res) => {
        this.listRuoli = {
          store: {
            type: 'array',
            data: res.sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1)),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero ruoli utenti');
      },
    });

    //Reparti
    this.repartiService.listTemp().subscribe({
      next: (res) => {
        this.listReparti = res;
      },
      error: (err) => {
        if (err?.error?.title) {
          notify(err.error.title, 'error');
        } else {
          notify('Errore recupero lista reparti', 'error');
        }
      },
    });
  }

  loadUtenti(request: Observable<Utente[]>) {
    this.gestioneUtentiSource = new CustomStore({
      key: 'id',
      load: async () => {
        try {
          const response = await firstValueFrom(request);
          return {
            data: response,
          };
        } catch {
          throw 'Data loading error';
        }
      },
      remove: (key) => {
        return firstValueFrom(this.utentiService.remove(key))
          .then(() => console.log('delete eseguito'))
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500 && error?.error?.title) {
              throw error.error.title;
            } else {
              throw 'Cancellazione utente fallita';
            }
          });
      },
      update: (key, values) => {
        return firstValueFrom(this.utentiService.update(key, values)).catch(
          (error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Update failed';
            }
          },
        );
      },
    });
  }

  nuovoUtente() {
    this.newUtente = new Utente();
    this.newUtente.escludiPolicyPassword = false;
    this.popupVisible = true;
    this.confermaPassword = '';
  }

  passwordComparison = () => this.password;

  passwordReset = () => {
    return this.newPassword;
  };

  onIlDatoNewPasswordEvent(newPwdData: AggiornaPasswordModel) {    
    const result = this.validationGroup.instance.validate(); //ESCLUSI DAI CONTROLLI CAMPI PASSWORD NOMEENTRAID E OBJECTENTRAID
    if (!result.isValid) {
      return;
    }

    // AuthBase e AuthAvanzato entrambi abilitati
    // VERIFICO CHE SIA COMPILATO UN CAMPO TRA NOMEENTRAID, OBJECTENTRAID E PASSWORD
    if (this.authBase && this.authAvanzato){
      const nome = this.newUtente.nomeEntraId?.trim() ?? '';
      const objectId = this.newUtente.objectId?.trim() ?? '';
      const password = newPwdData?.newPassword?.trim() ?? '';

      if (!nome && !objectId && !password) {
        this.messaggioErrore = 'Compilare almeno un campo tra Nome EntraID, Object ID e Password.';
        return;
      }
    }
  

    this.newUtente!.password = sha512.sha512(newPwdData.newPassword);
    this.newUtente!.livello = this.idRuolo;
    this.loadPanelVisible = true;
    this.utentiService.insert(this.newUtente!).subscribe({
      next: () => {
        this.loadPanelVisible = false;
        this.popupVisible = false;
        notify({
          message: 'Nuovo utente inserito',
          width: 300,
          shading: true,
          type: 'success',
        });
        this.tabella.instance.refresh();
        this.newUtente = undefined;
      },
      error: (error) => {
        this.loadPanelVisible = false;
        if (error?.error?.title) {
          notify(error?.error?.title, 'error');
        } else {
          notify('Errore inserimento nuovo utente ', 'error');
        }
      },
    });
  }

  onAggiungiUtenteClick() {
    const result = this.validationGroup.instance.validate();
    if (!result.isValid) {
      return;
    }

    // Solo AuthAvanzato: nome oppure Object ID obbligatorio
    if (!this.authBase && this.authAvanzato) {
      const nome = this.newUtente.nomeEntraId?.trim() ?? '';
      const objectId = this.newUtente.objectId?.trim() ?? '';
      if (!nome && !objectId) {
        this.messaggioErrore = 'Compilare almeno uno tra Nome EntraID, Object ID.';
        return;
      }
    }
    
    this.newUtente!.livello = this.idRuolo;
    this.loadPanelVisible = true;
    this.utentiService.insert(this.newUtente!).subscribe({
      next: () => {
        this.loadPanelVisible = false;
        this.popupVisible = false;
        notify({
          message: 'Nuovo utente inserito',
          width: 300,
          shading: true,
          type: 'success',
        });
        this.tabella.instance.refresh();
        this.newUtente = undefined;
      },
      error: (error) => {
        this.loadPanelVisible = false;
        if (error?.error?.title) {
          notify(error?.error?.title, 'error');
        } else {
          notify('Errore inserimento nuovo utente ', 'error');
        }
      },
    });
  }

  onIlDatoResetPasswordEvent(resetPasswordData: AggiornaPasswordModel) {
    const newCryptedPassword = sha512.sha512(resetPasswordData.newPassword);
    const newCryptedPasswordObj = new ResetPassword();
    newCryptedPasswordObj.password = newCryptedPassword;

    this.loadPanelVisible = true;
    this.utentiService
      .resetPassword(this.idUtente!, newCryptedPasswordObj)
      .subscribe({
        next: () => {
          this.loadPanelVisible = false;
          notify({
            message: 'Password aggiornata',
            width: 300,
            shading: true,
            type: 'success',
          });
          this.tabella.instance.refresh();
          this.popupResetPswVisible = false;
          this.usernameResetPassword = undefined;
        },
        error: (error) => {
          this.loadPanelVisible = false;
          if (error?.error?.title) {
            notify(error?.error?.title, 'error');
          } else {
            notify('Errore reset password utente', 'error');
          }
        },
      });
  }

  cancellaPopup() {
    this.newUtente = new Utente();
    this.popupVisible = false;
  }

  cancellaPopupResetPassword() {
    this.popupResetPswVisible = false;
    this.newPassword = '';
  }

  onModificaPasswordClick(e: any) {
    this.idUtente = e.data.id;
    this.popupResetPswVisible = true;
    this.usernameResetPassword = e.data.username;
  }

  onUpdating(e: any) {
    e.newData = Object.assign(e.oldData, e.newData);
    // if (e.newData.idRuolo === RUOLO_AMMINISTRATORE ||
    //   e.newData.idRuolo === RUOLO_SEGNALATORE_AMBIENTE_ESTERNO ||
    //   e.newData.idRuolo === RUOLO_SEGNALATORE_ESTERNO) {
    //   e.newData.idUfficio = null;
    // }
  }

  onRepartiChanged(e: any, cellInfo: any) {
  const idsSelezionati = e.value || [];
  
  const valoreStringa = idsSelezionati.join(';');
  
  cellInfo.setValue(valoreStringa);
}

  getRepartiValue(cellValue: any): any[] {
  if (!cellValue) return [];
  
  const stringArray = cellValue.toString().split(';').filter((val: string) => val.trim() !== '');

  const primoReparto = this.listReparti?.[0];
  if (primoReparto && typeof primoReparto.id === 'number') {
    return stringArray.map((val: string) => Number(val));
  }

  return stringArray;
}

  onExporting(e: any) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Utenti');
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer: any) => {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          'Utenti.xlsx',
        );
      });
    });
    e.cancel = true;
  }

  displayExprReparto(reparto: Reparti) {
    if (!reparto) return '';
    return reparto.codice + ' - ' + reparto.descrizione;
  }

  viewReparti(utente: Utente) {
    if (!utente.idsReparti) {
      return '';
    }
    const repartiScelti = utente.idsReparti.split(';');
    const rep = this.listReparti.filter((x) =>
      repartiScelti.includes(x.id.toString()),
    );
    let result = '';
    rep.forEach((repa) => {
      result += repa.codice + ' - ' + repa.descrizione + ', ';
    });
    result = result.substring(0, result.length - 2);
    return result;
  }

  onRepartiNewUtente(e: any) {
    this.newUtente!.idsReparti = e.value.join(';');
  }

isPasswordObbligatoria(){
  const nome = this.newUtente.nomeEntraId?.trim() ?? '';
  const objectId = this.newUtente.objectId?.trim() ?? '';
  this.passwordObbligatoria = (nome.length == 0 && objectId.length == 0) ? true : false;
}


}
